import { store } from "../store";
import { logOutUser } from "../store/actions/auth";
import AuthService from "../services/auth.service";
import history from '../utils/customHistory';

export const _setToken = (data) => {
  localStorage.setItem('candidateAccessToken', data.access.token);
  localStorage.setItem('candidateRefreshToken', data.refresh.token);
  localStorage.setItem('candidateExpiryToken', data.access.expires);
}

let refrestTimer;
export const logout = async () => {
  if (refrestTimer) {
    clearInterval(refrestTimer)
    refrestTimer = null;
  }

  localStorage.clear();
  store.dispatch(logOutUser()).then(()=>{
    history.push('/jobs');
    window.location.reload();
  })
}

export const setupRefreshTimer = async () => {
  if (localStorage.getItem('candidateAccessToken')) {
    /*const expiryToken = localStorage.getItem('candidateExpiryToken')

    const currentTime = new Date();
    const expiryTime = new Date(parseInt(expiryToken, 10) * 1000); // Parse the timestamp
    const durationInSeconds = moment(expiryTime).diff(currentTime, 'seconds');

    refrestTimer = setInterval(async () => {
      await callRefresh()
    }, (durationInSeconds - 100) * 1000)*/
  } else {
    logout()
  }
}

export const callRefresh = async _ => {
  const refreshData = await AuthService.callRefresh().then((response) => {
    if (response.statusCode === 200 || response.statusCode === 201) {
      _setToken(response.data.tokens)
    } else {
      logout()
    }
  }).catch((err) => {
    logout()
  });
  return refreshData
}
